import PropTypes from "prop-types";

import Img from "components/atoms/Img";
import LinkRouter from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";

const OnlineBankingTool = ({ data }) => {
  return (
    <div>
      <div className="container">
        <div className="row justify-center">
          <div className="row col-12 rounded-3xl bg-bbc-gradient-9 py-6 lg:col-10 lg:py-0">
            <div className="col-12 order-1 self-center pr-0 lg:col-5 lg:order-0">
              <Title
                text={data.title}
                as="h5"
                className="mb-6 pr-0 text-bbc-30px font-semibold capitalize text-bbc-main"
              />
              <p className="mb-6 text-base font-normal text-white">
                {data.description}
              </p>
              <div className="text-center lg:text-left">
                <LinkRouter
                  target="_blank"
                  className="rounded-[50px] border px-4 py-1 text-white "
                  href="#"
                >
                  Try Now
                </LinkRouter>
              </div>
            </div>
            <div className="col-12 order-0 text-center lg:col-7 lg:order-1 lg:text-left">
              <Img src={data.image} alt="online baking tool" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnlineBankingTool;

OnlineBankingTool.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
};

OnlineBankingTool.defaultProps = {
  className: "",
};
